/**
 * SEO Redirect Mixin
 * Provides handleSeoRedirect method for components that need to redirect based on API URLs
 */
export default {
  methods: {
    handleSeoRedirect(targetUrl) {
      // URL comes from our own API response (data.html.url), so no domain validation needed
      if (!targetUrl) return;

      const { pathname } = new URL(targetUrl);
      if (pathname !== this.$nuxt.$route.path) {
        const redirectFullPath = this.$nuxt.$route.fullPath.replace(this.$nuxt.$route.path, pathname);
        this.$nuxt.context.redirect(301, redirectFullPath);
      }
    },
  },
};
